import util from "../BsUtil"
import Env from "../BsGetEnv";
import BsGetXcx from "../BsGetXcx";
let user = {};
function getApplationCid() {
    return new Promise((resolve)=>{
        try {
            if(!window.DIDASDK){
                resolve({message:'DIDASDK没有引入！'});
                return;
            }
            let timer = setTimeout(()=>{
                resolve({});
                clearTimeout(timer);
                timer = null;
            }, 1000);
            window.DIDASDK.invoke('getUserInfo',{},res => {
                clearTimeout(timer);
                if (res) {
                    const obj = JSON.parse(res) || {}
                    resolve({
                        access_token  : obj.access_token  ,
                        cid : obj.cid 
                    });
                } else {
                    resolve({});
                }
            })
        } catch (error) {
            resolve({});
        }
    })
}
async function GetCid(){
    let cid = util.queryString('cid') || util.queryString('user_cid') || util.queryString('userCid') || sessionStorage.getItem('cid') ||'' ;
    let access_token = encodeURIComponent(util.queryString('access_token')) || sessionStorage.getItem('access_token') || '';
    let appId = ''
    cid = encodeURIComponent(cid)

    if(!cid || !access_token){
        let hash = location.hash.replace('#', '').split("?")[0]
        cid = util.getQueryVariable('user_cid', hash)
        access_token = util.getQueryVariable('access_token', hash)
        sessionStorage.setItem("appId", util.getQueryVariable('appId', hash));
    }

    if(!cid || !access_token){
        if(Env.inApplication && Env.isDidaPinche){
            return await getApplationCid();
        } else {
            let xcx = await BsGetXcx()
            if(!(xcx.isAli || xcx.isWx)){
                // 非小程序
                cid = cid || util.getCookie('cid');
                access_token =  access_token || util.getCookie('access_token')
            }
        }
    }
    if(access_token && access_token.includes('%')){
        while(access_token.includes('%')){
            access_token = decodeURIComponent(access_token)
        }
    }
    user = {
        access_token,
        cid,
    }
    return user
};

export default async function(userinfo){
    if(userinfo) {
        user = userinfo;
        return;
    }
    if(user.cid && user.access_token) return user;
    return await GetCid();
}


